import deepClone from 'clone-deep'

Array.remove = function (self, ...args) {
  let output = []
  for (let arg of args) {
    let index = self.indexOf(arg)
    if (index !== -1) {
      output.push(self.splice(index, 1))
    }
  }
  if (args.length === 1) {
    output = output[0]
  }
  return output
}

Array.toggleItem = function (self, v) {
  if (!self) {
    return
  }
  if (self.includes(v)) {
    Array.remove(self, v)
  } else {
    self.push(v)
  }
  return self
}

String.prototype.isValidRegex = function () { // eslint-disable-line
  try {
    new RegExp(this) // eslint-disable-line
    return true
  } catch (error) {
    return false
  }
}

window.mobileMode = false
if (navigator.userAgent.match(/ipad/i) || navigator.userAgent.match(/iphone/i) || navigator.userAgent.match(/android/i)) {
  window.mobileMode = true
  document.querySelector('html').classList.add('mobile-mode')
}

export function base32 (hex) {
  let charTable = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'

  let quintetCount = function (buff) {
    let quintets = Math.floor(buff.length / 5)
    return (buff.length % 5) === 0 ? quintets : (quintets + 1)
  }

  let plain = []
  for (let i = 0; i < hex.length / 2; i++) {
    plain.push(parseInt(`0x${hex[i * 2]}${hex[(i * 2) + 1]}`))
  }

  let i = 0
  let j = 0
  let shiftIndex = 0
  let digit = 0
  let encoded = ''

  while (i < plain.length) {
    let current = plain[i]

    if (shiftIndex > 3) {
      digit = current & (0xff >> shiftIndex)
      shiftIndex = (shiftIndex + 5) % 8
      digit = (digit << shiftIndex) | ((((i + 1) < plain.length) ? plain[i + 1] : 0) >> (8 - shiftIndex))
      i += 1
    } else {
      digit = (current >> (8 - (shiftIndex + 5))) & 0x1f
      shiftIndex = (shiftIndex + 5) % 8
      if (shiftIndex === 0) {
        i += 1
      }
    }

    encoded += charTable[digit]
    j += 1
  }

  i = j
  while (i < quintetCount(plain)) {
    encoded[i] = '='
    i += 1
  }

  return encoded
}

export function downloadAs (content, filename) {
  let blob
  if (content instanceof Blob) {
    blob = content
  } else {
    blob = new Blob([content], { type: 'text/plain' })
  }
  let elem = window.document.createElement('a')
  elem.href = window.URL.createObjectURL(blob)
  elem.download = filename
  document.body.appendChild(elem)
  elem.click()
  document.body.removeChild(elem)
}

export function forEachDraggedFile (event, processFile) {
  if (event.dataTransfer.items) {
    for (let item of event.dataTransfer.items) {
      if (item.kind === 'file') {
        processFile(item.getAsFile())
      }
    }
  } else {
    for (let file of event.dataTransfer.files) {
      processFile(file)
    }
  }
}

export function loadFileContent (file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.readAsText(file)
    fr.onload = () => resolve(fr.result)
    fr.onabort = reject
  })
}

const setTimeout = window[window.Zone.__symbol__('setTimeout')]
const clearTimeout = window[window.Zone.__symbol__('clearTimeout')]

export class ResettableTimeout {
  constructor (fn, timeout) {
    this.fn = fn
    this.timeout = timeout
    this.id = null
  }

  set (timeout) {
    this.clear()
    this.id = setTimeout(this.fn, timeout ?? this.timeout)
  }

  clear () {
    if (this.id) {
      clearTimeout(this.id)
    }
  }
}

export async function editOrRevert (object, callback) {
  const copy = deepClone(object)
  try {
    if (!await callback()) {
      Object.assign(object, copy)
    }
  } catch (e) {
    Object.assign(object, copy)
    throw e
  }
}
